import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService }    from '@ngx-translate/core';

@Pipe({
  name: 'jobStatusBooking',
})
export class JobStatusBookingPipe implements PipeTransform {

  constructor(
    private translateService : TranslateService
  ) {}

  transform( value : string ) {
    const typeMap = {
      A: this.translateService.instant('JOB_STATUS_TYPES.AWAITING'),
      B: this.translateService.instant('JOB_STATUS_TYPES.BOOKED'),
      C: this.translateService.instant('JOB_STATUS_TYPES.COMPLETE'),
      F: this.translateService.instant('JOB_STATUS_TYPES.FINALISED'),
      I: this.translateService.instant('JOB_STATUS_TYPES.INSPECTION_IN_PROGRESS'),
      N: this.translateService.instant('JOB_STATUS_TYPES.NOTIFIED'),
      P: this.translateService.instant('JOB_STATUS_TYPES.PARTS'),
      U: this.translateService.instant('JOB_STATUS_TYPES.WAITING_FOR_USER_APPROVAL'),
      W: this.translateService.instant('JOB_STATUS_TYPES.WIP')
    };

    return typeMap[value] || '';
  }
}